import styles from "./spinner.module.scss";
import spinner from "../../shared/images/spinner.gif"
import {useTranslation} from "react-i18next";

export const Spinner = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.body}>
        <img src={spinner} alt=""/>
        <span>{t("common.loading")}</span>
      </div>
    </div>
  );
}